import { FlowDurationSchema, FlowIteratorBlockErrorResolution } from 'flow-schema';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType, ProducedType } from '../../base/baseSchema.js';
import { LlmPromptBlockBaseSchema } from '../../llmPrompt/config.js';
import { RestBlockBaseSchema } from '../../rest/config.js';
import { ScriptedBlockBaseSchema } from '../../script/config.js';
import { SubFlowV1BlockSchema } from '../../subFlow/v1/config.js';

export const AllowedActionBlockSchema = z.discriminatedUnion('type', [
  LlmPromptBlockBaseSchema,
  ScriptedBlockBaseSchema,
  RestBlockBaseSchema,
  SubFlowV1BlockSchema,
  // Add other block types here
]);

export const IteratorV1BlockConfigSchema = z.object({
  /**
   * A list of items to iterate: run {@link action} for each item
   */
  items: z.string().or(z.array(z.unknown())),

  /**
   * (Optional) a top-level field in the {@link items} array of objects to use as the unique id for items
   */
  itemKey: z.string().optional(),

  /**
   * The lambda action to execute for each entry in the list
   */
  action: AllowedActionBlockSchema,

  /**
   * Action to take on an error taking action for a single item in the list
   */
  errorResolution: z.enum(FlowIteratorBlockErrorResolution),

  /**
   * (Optional) A duration to wait between each item in the list
   */
  iterationStepDuration: FlowDurationSchema.optional(),
});

export const IteratorV1BlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.IteratorV1),
  config: IteratorV1BlockConfigSchema,
  returnType: z.literal(ProducedType.Any).default(ProducedType.Any),
});

export type IteratorV1Block = z.infer<typeof IteratorV1BlockSchema>;
